var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('com-community-search',{attrs:{"typeOfView":"partner"},on:{"search":_vm.handleSearch}}),_c('com-community-list',{ref:"table",attrs:{"typeOfView":"partner","default-params":_vm.defaultParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }